<template>
  <p class="text-primary">
    {{ shipmentName }}<br>
    <small class="text-secondary">
      Koszt dostawy: <strong class="text-primary">{{ roundProperly(shipmentPrice) }} zł</strong>
    </small>
  </p>
</template>

<script>
import CustomDecimals from './../../../utils/CustomDecimals.js';

export default {
  name: 'order-info-shipping',
  props: [
    'shipmentName',
    'shipmentPrice'
  ],
  methods: {
    roundProperly (value, decimals = 2) {
      return CustomDecimals.roundProperly(value, decimals);
    }
  }
}
</script>
